import type { SystemInfo } from '@shared/types/system';

/** «v5.0.2»; «dev» и пустая версия остаются как есть, чтобы не получилось «vdev». */
export function formatVersionLabel(version?: string): string {
  if (!version) return '';
  return /^\d/.test(version) ? `v${version}` : version;
}

/** Одна строка для обращения в поддержку: версия · коммит · время · домен; коммит фронта — только при расхождении. */
export function buildSupportText(info: SystemInfo, uiCommit = ''): string {
  return [
    formatVersionLabel(info.version),
    info.commit ? info.commit.slice(0, 8) : '',
    info.builtAt ?? '',
    info.dirty ? 'dirty' : '',
    uiCommit && commitsDiffer(info.commit, uiCommit) ? `ui ${uiCommit.slice(0, 8)}` : '',
    info.domain,
  ]
    .filter(Boolean)
    .join(' · ');
}

/** Коммит, из которого собран фронтенд (вшивается Vite define при сборке); '' если неизвестен. */
export function frontendCommit(): string {
  return typeof __APP_COMMIT__ === 'string' ? __APP_COMMIT__ : '';
}

/**
 * Расходятся ли коммиты бэкенда и фронтенда. Сравнение по общему префиксу: один из
 * них может быть коротким. Неизвестная сторона расхождения не даёт.
 */
export function commitsDiffer(a?: string, b?: string): boolean {
  if (!a || !b) return false;
  return !(a.startsWith(b) || b.startsWith(a));
}
